module.exports = __webpack_public_path__ + "static/values-pursue-excellence-f3b240cdaff865ecf5b530f86fecd9ad.svg";